import type { enMessages } from './messages-en';

export const SUPPORTED_LOCALES = ['en', 'ru'] as const;

export type Locale = (typeof SUPPORTED_LOCALES)[number];
export type MessageKey = keyof typeof enMessages;
export type MessageCatalog = Readonly<Record<MessageKey, string>>;

const loadedCatalogs = new Map<Locale, MessageCatalog>();

export function isSupportedLocale(value: string): value is Locale {
  return (SUPPORTED_LOCALES as readonly string[]).includes(value);
}

export function loadedMessageCatalog(locale: Locale): MessageCatalog | null {
  return loadedCatalogs.get(locale) ?? null;
}

export function primeMessageCatalog(locale: Locale, catalog: MessageCatalog): void {
  loadedCatalogs.set(locale, catalog);
}

export async function loadMessageCatalog(locale: Locale): Promise<MessageCatalog> {
  const loaded = loadedMessageCatalog(locale);
  if (loaded) return loaded;

  const catalog = await (locale === 'ru'
    ? import('./messages-ru').then(({ ruMessages }) => ruMessages)
    : import('./messages-en').then(({ enMessages }) => enMessages));
  primeMessageCatalog(locale, catalog);
  return catalog;
}
